import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'rn-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: true,
    imports: [FormsModule]
})
export class CheckboxComponent {
  @Input() labelText?: string;
  @Input() inputName: string;
  @Input() checkboxModel: boolean;
  @Output() checkboxModelChange: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  handleChange() {
    this.checkboxModelChange.emit(this.checkboxModel);
  }
}
